<template>
  <div
    v-if="richText"
    :class="[$style.root, defaultFontSize ? 'font-size-default' : '']"
  >
    <core-truncated-text-component
      :rich-text="richText"
      :rich-text-truncated="richTextTruncated"
    />
  </div>
</template>

<script lang="ts" setup>
const props = defineProps({
  richText: {
    type: String,
    required: true
  },
  richTextTruncated: {
    type: String,
    required: false
  },
  defaultFontSize: {
    type: Boolean,
    default: true
  }
})
</script>

<style module>
.root {
}
</style>
